import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ExtendValidity = lazy(() => import('../components/ExtendValidity'));

const ExtendValidityRoute: RouteObject = {
  path: 'scheme-management/extend-validity',
  element: <ExtendValidity />,
};

export default ExtendValidityRoute;
